import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-156e0b6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { ref, watch } from "vue";
import AppEditor from "@/components/AppEditor.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFieldEditor',
  props: {
    modelValue: String,
    value: String,
    label: String,
    max: {
        type: Number,
        default: 2000
    },
    border: {
        type: Boolean,
        default: false
    }
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

const editorVal = ref('');
const editorText = ref('');
const placeholder = ref(`请输入${props.label}，建议200字以上`);

// const appEditorRef = ref<Node>();
const appEditorRef = ref();

const rules = ref(
    [
        {
            validator() {
                if (editorText.value.trim().length > 0) return true
                return '请输入' + props.label;
            }
        },
        {
            validator() {
                if (appEditorRef.value.validateLen()) return true
                return '超过限制字数';
            }
        },
    ]
);

watch(() => editorVal.value, (newVal) => {
    emits("update:modelValue", newVal);
})




return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!

  return (_openBlock(), _createBlock(_component_van_cell_group, { border: false }, {
    default: _withCtx(() => [
      _createVNode(_component_van_field, {
        label: __props.label,
        class: "app-field-editor-label",
        border: false
      }, {
        input: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_van_field, {
        class: _normalizeClass(["app-field-editor", { 'bottom-border': __props.border }]),
        "input-align": "left",
        border: false,
        rules: rules.value,
        required: "",
        modelValue: editorText.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editorText).value = $event))
      }, {
        input: _withCtx(() => [
          _createVNode(AppEditor, {
            modelValue: editorVal.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editorVal).value = $event)),
            editorText: editorText.value,
            "onUpdate:editorText": _cache[1] || (_cache[1] = ($event: any) => ((editorText).value = $event)),
            ref_key: "appEditorRef",
            ref: appEditorRef,
            placeholder: placeholder.value,
            max: __props.max
          }, null, 8, ["modelValue", "editorText", "placeholder", "max"])
        ]),
        _: 1
      }, 8, ["class", "rules", "modelValue"])
    ]),
    _: 1
  }))
}
}

})